/* styles.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5v1qpb%7Bflex-direction%3Arow%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuI7V3%7Bjustify-content%3Aspace-between%7D%0A%40keyframes%20kv5mpd0%7B0%25%7Bbackground-position%3A100%25%200%7Dto%7Bbackground-position%3A-100%25%200%7D%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._2fBhtei8Wc%7Banimation%3Akv5mpd0%201.2s%20linear%20infinite%20forwards%7D%0A._3OqcjTqzz9%7Bbackground-size%3A300%25%20100%25%7D%0A._0KLXruaVjy%7Bbackground-color%3Avar(--ds-skeleton-subtle%2C%2317171708)%7D%0A._2z4m57UZDI%7Bbackground-repeat%3Ano-repeat%7D%0A._0jFU0VxpxF%7Bheight%3A9pt%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D");











import { type CSSProperties, type ReactNode } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- jsx is used by the JSX pragma

import { type Props } from './types';

// eslint-disable-next-line @compiled/no-invalid-css-map
const shimmer = null;
const styles = {
  loadingSkeletonContainer: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuI7V3",
  loadingSkeleton: "_0bjKvDKxmn _2fBhtei8Wc _3OqcjTqzz9 _0KLXruaVjy _2z4m57UZDI _0jFU0VxpxF _39xV02N91d"
};
export function LoadingSkeletonContainer({
  children,
  margin,
  style
}: {
  children?: ReactNode;
  margin?: string;
  style?: CSSProperties;
}): JSX.Element {
  return <div
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic margin passed as inline style
  style={{
    margin: margin ?? '0px',
    ...style
  }} className={ax([styles.loadingSkeletonContainer])}>
			{children}
		</div>;
}
export function LoadingSkeleton({
  marginLeftPx = 0,
  marginBottomPx = 0,
  marginRightPx = 0,
  marginTopPx = 0,
  width = '100%',
  borderRadius = "var(--ds-radius-small, 4px)",
  backgroundColor = "var(--ds-skeleton-subtle, #17171708)",
  shimmerColor = "var(--ds-skeleton, #0515240F)",
  height = '12px'
}: Props): JSX.Element {
  return <div
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic props passed as inline styles
  style={{
    width,
    height,
    borderRadius,
    backgroundColor,
    backgroundImage: `linear-gradient( to right, transparent 0%, transparent 40%, ${shimmerColor} 50%, transparent 60%, transparent 100%)`,
    marginRight: `${marginRightPx}px`,
    marginTop: `${marginTopPx}px`,
    marginBottom: `${marginBottomPx}px`,
    marginLeft: `${marginLeftPx}px`
  }} className={ax([styles.loadingSkeleton])} />;
}